// extracted by mini-css-extract-plugin
module.exports = {"jockoCoverImage":"for-business_jockoCoverImage__G9zWO"};